import axios, { AxiosResponse } from "axios";
import { authHeader } from "../Utilities";
import { API_URL } from "../constants";
import { message } from "antd";

export class IndexService {
    indexRun(projectId: string, runId: string): Promise<AxiosResponse<any>> {
        return axios.post(
            `${API_URL}/projects/${projectId}/processing_runs/${runId}/reindex`,
            {},
            { headers: authHeader() }
        );
    }

    indexProject(projectId: string): Promise<AxiosResponse<any>> {
        return axios.post(
            `${API_URL}/projects/${projectId}/reindex`,
            {},
            { headers: authHeader() }
        );
    }
}

export class LoggedIndexService {
    private _origin: IndexService;
    private _loggedThen: (_: any) => void;
    private _loggedCatch: (_: any) => void;

    constructor(origin: IndexService) {
        this._origin = origin;
        this._loggedThen = (_: any) => {
            message.success("Index process started");
        };
        this._loggedCatch = (_: any) => {
            message.error("Index process failed");
        };
    }

    indexRun(projectId: string, runId: string): Promise<void> {
        return this._origin.indexRun(projectId, runId)
            .then(this._loggedThen)
            .catch(this._loggedCatch);
    }

    indexProject(projectId: string): Promise<void> {
        return this._origin.indexProject(projectId)
            .then(this._loggedThen)
            .catch(this._loggedCatch);
    }
} 